<template>
    <div>
        <breadcrumb :items="breadcrumbs"></breadcrumb>
        <div @click="goToNextAnimal()" class="float-right mt-n10 mr-5 primary--text subtitle-2">{{ $t('animal.nextAnimals') }} ></div>
        <v-container fluid>
            <v-card  >
                 <v-toolbar
                    absolute
                    tile
                    height="78"
                    color="transparent"
                    flat
                    class="allRight"
                >
                    <v-toolbar-title>
                        <v-list-item>
                            <v-list-item-content>
                                <v-list-item-title class="text-h5 font-weight-bold">
                                # {{ $route.params.animal_number}}
                                </v-list-item-title>
                                <v-list-item-subtitle>
                                {{ animal.name }}
                                </v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>
                    </v-toolbar-title>
                    <v-spacer></v-spacer>

                    <v-btn :to="{ name: 'EditAnimal', params: {animal_number: $route.params.animal_number, source: $route.params.source}}" color="primary">
                        {{$t('animal.editAnimal')}}
                    </v-btn>
                </v-toolbar>
            </v-card>
            <v-card color="transparent" min-height="900" flat elevation="0" class="pa-2">
                <v-navigation-drawer
                    permanent
                    absolute
                    floating
                    fixed
                    id="apptest"
                    elevation="5"
                >
                    <v-list>
                        <v-list-item class="pa-2">
                            <v-list-item-avatar
                                tile
                                size="235"
                                contain
                                class="rounded-lg"
                            >
                                <v-img 
                                    class="pa-2" 
                                    :src="animalImage"
                                    :lazy-src="animalImage"
                                >
                                    <template v-slot:placeholder>
                                        <v-row
                                            class="fill-height ma-0"
                                            align="center"
                                            justify="center"
                                        >
                                            <v-progress-circular
                                            indeterminate
                                            color="grey lighten-5"
                                            ></v-progress-circular>
                                        </v-row>
                                    </template>
                                </v-img>
                            </v-list-item-avatar>
                        </v-list-item>
                    </v-list>
                    <v-divider width="100%"></v-divider>
                    <v-list
                        nav
                        dense
                    >
                        <v-list-item v-for="item in animalOptions"  :key="item.title" active-class="secondary2" link :to="item.url">
                            <v-list-item-icon>
                                <!-- <v-icon>{{ item.icon }}</v-icon> -->
                                <v-img :src="item.icon"></v-img>
                            </v-list-item-icon>
                            <v-list-item-title>{{ item.title }}</v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-navigation-drawer>
               
                <v-card-text class="c-right">
                    <v-card flat>
                        <v-card-title>
                            <v-row class="elevation-0" width="100%">
                                <v-col cols="1.5" class="" >
                                    <v-list dense>
                                    <v-list-item>
                                        <v-list-item-content>
                                            <v-list-item-subtitle>
                                            {{$t('type')}}
                                            </v-list-item-subtitle>
                                            <v-list-item-title class="text-h6 mt-2 text-capitalize">
                                            {{ animal.animalType }}
                                            </v-list-item-title>
                                            
                                        </v-list-item-content>
                                    </v-list-item>
                                    </v-list>
                                </v-col>
                                <v-divider vertical inset></v-divider>
                                <v-col cols="2" class="" >
                                    <v-list dense>
                                    <v-list-item>
                                        <v-list-item-content>
                                            <v-list-item-subtitle>
                                            {{$t('animal.tag')}}#
                                            </v-list-item-subtitle>
                                            <v-list-item-title class="text-h6 mt-2 text-wrap">
                                            {{ animal.tagNumber }}
                                            </v-list-item-title>
                                            
                                        </v-list-item-content>
                                    </v-list-item>
                                    </v-list>
                                </v-col>
                                <v-divider vertical inset></v-divider>
                                <v-col cols="2" class="" >
                                    <v-list dense>
                                    <v-list-item>
                                        <v-list-item-content>
                                            <v-list-item-subtitle>
                                            {{$t('weight')}}
                                            </v-list-item-subtitle>
                                            <v-list-item-title class="text-h6 mt-2 text-wrap">
                                            {{ animal.birthWeight }} {{$t('kG')}}
                                            </v-list-item-title>
                                            
                                        </v-list-item-content>
                                    </v-list-item>
                                    </v-list>
                                </v-col>
                                <v-divider vertical inset></v-divider>
                                <v-col cols="2" class="" >
                                    <v-list dense>
                                    <v-list-item>
                                        <v-list-item-content>
                                            <v-list-item-subtitle>
                                            {{$t('animal.dateOfBirth')}}
                                            </v-list-item-subtitle>
                                            <v-list-item-title class="text-h6 mt-2 text-wrap">
                                            {{ formatDate(animal.dob) }}
                                            </v-list-item-title>
                                            
                                        </v-list-item-content>
                                    </v-list-item>
                                    </v-list>
                                </v-col>
                                <v-divider vertical inset></v-divider>
                                <v-col cols="2" class="" >
                                    <v-list dense>
                                    <v-list-item>
                                        <v-list-item-content>
                                            <v-list-item-subtitle>
                                            {{$t('animal.gender')}}
                                            </v-list-item-subtitle>
                                            <v-list-item-title class="text-h6 mt-2 text-wrap">
                                            {{ animal.gender }}
                                            </v-list-item-title>
                                            
                                        </v-list-item-content>
                                    </v-list-item>
                                    </v-list>
                                </v-col>
                                <v-divider vertical inset></v-divider>
                                <v-col cols="2" class="" >
                                    <v-list dense>
                                    <v-list-item>
                                        <v-list-item-content>
                                            <v-list-item-subtitle>
                                            {{$t('status')}}
                                            </v-list-item-subtitle>
                                            <v-list-item-title class="text-h6 mt-2 text-wrap">
                                            {{ animal.status || $t('farm.onTheFarm') }}
                                            </v-list-item-title>
                                            
                                        </v-list-item-content>
                                    </v-list-item>
                                    </v-list>
                                </v-col>
                            </v-row>
                        </v-card-title>
                    </v-card>
                    <router-view :current-animal="animal"/>
                </v-card-text>
        </v-card>
        </v-container>
    </div>
</template>
<script>
import loadingMixin from "@/mixins/LoadingMixin"
import generalMixin from "@/mixins/GeneralMixin"

import AnimalService from "@/_services/AnimalService"
export default {
    created() {
        const fetchData = async () => {
            await this.getSingleAnimal(this.$route.params.animal_number, this.$route.params.source)
        };
        fetchData();
    },
    data() {
        return {
            animal: {},
            animalImage: '/img/no_img.png',
            animalCounter: 0,
            animals: [],
            animalOptions: [
                { title: this.$t('animal.details'), icon: "/icons/Details.svg", url: { name: 'AnimalDetails'}},
                { title: this.$t('animal.performance'), icon: "/icons/Performance.svg", url: { name: 'AnimalPerformance'}},
                { title: this.$t('animal.feedInfo'), icon: "/icons/Feed Info.svg", url: { name: 'AnimalFeedInfo'}},
                { title: this.$t('animal.geneticWorth'), icon: "/icons/Genetics.svg", url: { name: 'AnimalGeneticWorth'}},
                { title: this.$t('animal.conception'), icon: "/icons/Conceptiontt.svg", url: { name: 'AnimalConception'}},
                { title: this.$t('animal.healthRecord'), icon: "/icons/Health.png", url: { name: 'AnimalHealthReord'}},
                { title: this.$t('animal.genotypeData'), icon: "/icons/Data.svg", url: { name: 'AnimalGeneData'}},
                { title: this.$t('animal.reminders'), icon: "/icons/Reports.svg", url: { name: 'AnimalReminders'}},
                { title: this.$t('animal.activityLog'), icon: "/icons/Activity.svg", url: { name: 'AnimalActivityLog'}},
                { title: this.$t('notes'), icon: "/icons/Notes.svg", url: { name: 'AnimalNotes'}},
            ],
            breadcrumbs: [
                {
                    text: this.$t('dashboard'),
                    disabled: false,
                    to: '/',
                },
                {
                    text: this.$t('animals'),
                    to: {
                        name: 'Animals'
                    },
                    exact: true 
                },
                {
                    text: '',
                    disabled: true,
                },
            ],
        }
    },
    async mounted() {
        this.animals = localStorage.getItem("animals");
        this.animals = this.animals.split(',')
    },
    methods: {
        async getSingleAnimal(animal_number, source) {
            this.startLoading()
            AnimalService.getSingleAnimal(animal_number, source)
            .then( async (res) => {
                this.animal = res.data.animalDetails
                this.breadcrumbs[2].text = this.animal.name
                await this.$store.dispatch('setCurrentAnimal', res.data.animalDetails)
                if(this.animal.img.url != null && this.animal.img.url != '')
                    this.animalImage = this.animal.img.url;
                this.stopLoading()
            })
            .catch( err => {
                console.log(err)
                this.stopLoading()
            });
        },
        goToNextAnimal(){
            this.animalCounter++;
            let animalNumber = this.animals[this.animalCounter];
            // let index = this.animals.indexOf(animalNumber)
            if(this.animals.length < this.animalCounter+1 ){
                // disable link
                return;
            }
           
            this.$router.push({
                name: "AnimalDetails",
                params: { animal_number: animalNumber },
            });

            //  this.$route.params.animal_number = animalNumber;
            this.getSingleAnimal(animalNumber, '');
        }
    },
    mixins: [loadingMixin, generalMixin]
}
</script>

<style  lang="scss" scoped>
    .border-top {
        border-top: 1px solid;
        border-bottom: 1px solid;
        border-color: $outline-color;
    }
    .border-right {
        border-right: 1px solid;
        border-color: $outline-color;
    }
    .allRight {
        transform: translateY(0px) !important; 
        left: 256px !important; 
        right: 0px !important;
    }
    .c-right {
        padding: 78px 0px 0px 256px !important;
    }
    .v-list .v-list-item--active {
        color: white;
    }
</style>
